import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { GeneralesService } from 'src/app/services/generales.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {
  ChangeForm: FormGroup;
  progress = false;
  MensajeError = false;
  MensajeSucces = false;
  btnEnviar = false;
  validacionDisponible = false;
  mensaje = '';
  validarionsRut: any;
  constructor(fb: FormBuilder, rutValidator: RutValidator, private servi: GeneralesService) {
    this.validarionsRut = rutValidator;
    this.ChangeForm = fb.group({
      Rut: ['', [Validators.required, Validators.maxLength(50), this.validarionsRut, Validators.minLength(3)]],
      Passaporte: [],
      ApellidoP: ['', [Validators.required]],
      EsRut: [true]
    });
  }

  ngOnInit(): void {
    // This is intentional
  }

  Solicitud() {
    this.validateAllFormFields(this.ChangeForm);
    if (this.ChangeForm.valid) {
      this.progress = true;
      this.servi.getEmailByRut(this.ChangeForm.controls.Rut.value).subscribe(
        (data: string) => {

          if (data !== '') {
            this.mensaje = 'El correo es: ' + data;
            this.ChangeForm.reset();
          } else {
            this.mensaje = 'No se encuentran email asociado, a la busqueda.'
          }
          this.MensajeSucces = true;
          setTimeout(() => {
            this.ChangeForm.reset();
            this.MensajeSucces = false;
          }, 5000);
          this.progress = false;
          this.ChangeForm.reset();
        },
        (error) => {
          this.MensajeError = true;
          setTimeout(() => {
            this.MensajeError = false;
          }, 5000);
          this.progress = false;
        },
        () => {
          // This is intentional
        }
      );
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
